import { styled } from '@mui/material';

import { Button } from '../Button';

import type { BannerButton, BannerCategory, BannerHierarchy } from './types';

interface BannerButtonProps {
  buttonProps: BannerButton;
  color: BannerCategory;
  hierarchy: BannerHierarchy;
}

const BannerButton = (props: BannerButtonProps) => {
  const { buttonProps, hierarchy, color } = props;
  const { label, ...others } = buttonProps;

  if (!label) return null;

  let buttonVariant: 'inverse' | 'tertiary';
  if (hierarchy === 'high') {
    // filled variant에서 warning 색상인 경우는 tertiary 사용
    buttonVariant = color === 'warning' ? 'tertiary' : 'inverse';
  } else {
    buttonVariant = 'tertiary';
  }

  return (
    <StyledBannerButton size="md" variant={buttonVariant} {...others}>
      {label}
    </StyledBannerButton>
  );
};

export default BannerButton;

const StyledBannerButton = styled(Button)({
  maxWidth: '300px',
  '& span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
  },
});
